<script>
import { v4 as uuidv4 } from 'uuid'
import isEmpty from 'lodash/isEmpty'
export default {
  name: 'select.generic',
  props: {
    value: { type: [String, Number] },
    id: { type: String, default: () => uuidv4() },
    label: { type: String },
    labelColsSm: { type: String, default: '12' },
    labelColsMd: { type: String },
    labelColsLg: { type: String },
    labelColsXl: { type: String },
    width: { type: [String, Number] },
    maxWidth: { type: [String, Number] },
    textAlign: { type: String, default: 'left' },
    append: { type: String },
    prepend: { type: String },
    onlyShowError: { type: Boolean, default: true },
    hideErrorMessages: { type: Boolean, default: false },
    hideValidationIcon: { type: Boolean, default: true },
    isValid: { type: Boolean, default: true },
    errorMessages: { type: Array }
  },
  data () {
    return {
      selected: null
    }
  },
  watch: {
    value: {
      handler (v) {
        this.selected = v
      },
      immediate: true
    }
  },
  methods: {
    onInputHandler (v) {
      v = isEmpty(v) ? null : v
      this.$emit('input', v)
    }
  }
}
</script>
<template>
  <b-form-group
    :label-for="id"
    :label-cols-sm="labelColsSm"
    :label-cols-md="labelColsMd"
    :label-cols-lg="labelColsLg"
    :label-cols-xl="labelColsXl"
    :label-class="{ 'd-none': !(!!label || !!$slots.label) }"
    class="d-flex align-items-center"
    :class="{
      'is-invalid': !isValid,
      'is-valid': isValid && !onlyShowError
    }"
  >
    <template v-slot:label>
      <slot name="label">
        <div
          class="d-flex align-items-center pointer"
          v-if="label || !!$slots.label"
        >
          {{ label }}
        </div>
      </slot>
    </template>
    <b-input-group :prepend="prepend" :append="append">
      <slot name="prepend"></slot>
      <b-form-radio-group
        :id="id"
        v-bind="$attrs"
        v-on:focus="$event.target.select()"
        v-on="$listeners"
        v-model="selected"
        :style="{ maxWidth, width, textAlign }"
        :class="{
          'is-invalid': !isValid,
          'is-valid': isValid && !onlyShowError,
          'hide-icon': hideValidationIcon
        }"
        :aria-describedby="`err_${id}`"
      ></b-form-radio-group>
      <slot name="append"></slot>
    </b-input-group>
    <b-form-invalid-feedback
      :id="`err_${id}`"
      v-if="!isValid && !hideErrorMessages"
    >
      <slot name="errors">
        <template v-if="!errorMessages">Fix this field</template>
        <template v-else>
          <span
            class="d-block"
            v-for="(err, idx) in errorMessages"
            :key="`err_${id}_${idx}`"
            >{{ err }}</span
          >
        </template>
      </slot>
    </b-form-invalid-feedback>
  </b-form-group>
</template>
